/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Landing_Gate_TitleInputs */

const en_landing_gate_title = /** @type {(inputs: Landing_Gate_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in to book ${i?.time}`)
};

const pl_landing_gate_title = /** @type {(inputs: Landing_Gate_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zaloguj się, żeby zarezerwować ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Sign in to book {time}" |
*
* @param {Landing_Gate_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_gate_title = /** @type {((inputs: Landing_Gate_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Gate_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_gate_title(inputs)
	return en_landing_gate_title(inputs)
});